function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfits(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#894BA2"
    },
    d: "M470.3,86.8l-72.026-72.025c-3.303-3.302-8.659-3.302-11.961,0L314.287,86.8 c-2.419,2.42-3.143,6.057-1.834,9.218c1.309,3.161,4.394,5.221,7.814,5.221h26.147v357.298c0,4.672,3.787,8.458,8.458,8.458h74.841 c4.671,0,8.458-3.786,8.458-8.458V101.24h26.147c3.422,0,6.505-2.06,7.814-5.221C473.443,92.859,472.719,89.221,470.3,86.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#763794"
    },
    d: "M398.275,14.775c-0.697-0.697-1.49-1.238-2.331-1.641v453.862h33.771 c4.671,0,8.458-3.786,8.458-8.458V101.24h26.147c3.422,0,6.505-2.06,7.814-5.221c1.309-3.161,0.585-6.798-1.834-9.218 L398.275,14.775z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F77935"
    },
    d: "M293.421,150.744H218.58c-4.671,0-8.458,3.786-8.458,8.458v299.337c0,4.672,3.787,8.458,8.458,8.458 h74.841c4.671,0,8.458-3.786,8.458-8.458V159.202C301.879,154.53,298.092,150.744,293.421,150.744z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D9510D"
    },
    d: "M293.421,150.744h-33.833v316.254h33.833c4.671,0,8.458-3.786,8.458-8.458V159.202 C301.879,154.53,298.092,150.744,293.421,150.744z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFDB56"
    },
    d: "M157.066,244.261H82.223c-4.671,0-8.458,3.786-8.458,8.458v205.821c0,4.672,3.787,8.458,8.458,8.458 h74.842c4.671,0,8.458-3.786,8.458-8.458V252.719C165.524,248.047,161.737,244.261,157.066,244.261z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FBA806"
    },
    d: "M157.066,244.261h-33.833v222.737h33.833c4.671,0,8.458-3.786,8.458-8.458V252.719 C165.524,248.047,161.737,244.261,157.066,244.261z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#808080"
    },
    d: "M503.542,499.701H8.458c-4.671,0-8.458-3.786-8.458-8.458c0-4.672,3.787-8.458,8.458-8.458h495.084 c4.671,0,8.458,3.786,8.458,8.458C512,495.915,508.213,499.701,503.542,499.701z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfits);
export default __webpack_public_path__ + "static/media/profits.fd70c0dc3773e6cad62702203d00425a.svg";
export { ForwardRef as ReactComponent };